export const getMyOrganization = async (user: any) => {
  const { error, result: organization } = await aeria.organization.get.POST({
    filters: {
      _id: user.current_organization,
    },
  })

  if (error) {
    return {
      _tag: 'Error',
      error
    }
  }

  const member = organization.members?.find((m: any) => m.user?._id.toString() === user?._id.toString())
  if (!member) {
    return {
      _tag: 'Error',
      error: "Not a member"
    }
  }

  return {
    _tag: 'Result',
    result: {
      ...organization,
      me: member,
    }
  }
}
